import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController, ModalController } from 'ionic-angular';
import { Observable } from 'rxjs/Rx';
import { UsersService } from '../../services/users/users-service';
import { User } from '../../models/user';
import { EditUserModalPage } from '../edit-user-modal/edit-user-modal';
import { CreateUserModalPage } from '../create-user-modal/create-user-modal';

@IonicPage()
@Component({
  selector: 'page-admin-users',
  templateUrl: 'admin-users.html',
})
export class AdminUsersPage {
  public Users: Array<User>;
  public originalUsers: Array<User>;

  ionViewCanEnter() {
    let self: AdminUsersPage = this;
    return new Promise((resolve, reject) => {
      self.loadUsers().subscribe(
        res => {resolve(null)},
        rej => {resolve(null)}
      )
    });
  }

  private loadUsers() {
    let self: AdminUsersPage = this;
    return Observable.create(observable => {
      self.usersService.all()
        .subscribe(
          res => {
            self.Users = res.map(function(u){ return new User(u); });
            self.originalUsers = res.map(function(u){ return new User(u); });
            observable.next();
          },
          rej => {
            let toast = self.toastCtrl.create({ message: rej.error.message, duration: 9000, position: "top"});
            toast.present();
            observable.next();
          },
        );
    });
  }

  private editUser(EditUser: User) {
    let editUserModal = this.modalCtrl.create(EditUserModalPage, {user: EditUser});
    let self: AdminUsersPage = this;

    editUserModal.onDidDismiss(resUser => {
      self.Users = self.Users.map(function(u){
        return parseInt(u.get("id")) === parseInt(resUser.get("id")) ? resUser : u;
      })
    });

    editUserModal.present();
  }

  createUser() {
    let createUserModal = this.modalCtrl.create(CreateUserModalPage);
    let self: AdminUsersPage = this;

    createUserModal.onDidDismiss(resUser => {
      let loading = self.loadingCtrl.create({ content: "Updating Users..." });

      loading.present();

      self.loadUsers()
        .subscribe(
          () => { loading.dismiss(); },
          () => { loading.dismiss(); }
        );
    });

    createUserModal.present();
  }

  userSearch(searchEvent: any) {
    let term = searchEvent.target.value ? String(searchEvent.target.value) : false;

    if( term && term.trim().length >= 3 )
    {
      // get user search results
      //let self: AdminUsersPage = this;
      this.usersService.search({global: term}).subscribe(response => {
        this.Users = response.map(function(u){ return new User(u); });
      });
    }

    else
    {
      // set cached users.
      this.Users = this.originalUsers;
    }
  }

  userSelected($event: any, SelectedUser: User) {
    this.editUser(SelectedUser);
  }

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private usersService: UsersService) {}
}



// WEBPACK FOOTER //
// ./src/pages/admin-users/admin-users.ts